import { render } from "./comment-flag-modal.vue?vue&type=template&id=45d636d4"
import script from "./comment-flag-modal.vue?vue&type=script&lang=js"
export * from "./comment-flag-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__